/**
 * It is a small class with static methods (vias) that make it easier/faster to use native methods from window.history
 */
export class ManageBrowserHistory {
  /**
   * Push a new point to the browser history
   * @param {string} path - add a new path
   * @param {any} reason - add a new state
   */
  static pushState(path: string, state: string = "") {
    window.history.pushState(state, "", path);
  }

  /**
   * Replace current path and state
   * @param {string} path - replace current path
   * @param {any} reason - replace current state
   */
  static replaceState(path: string, state: string = "") {
    window.history.replaceState(state, "", path);
  }

  /**
   * Return current state
   * @returns {any} current state
   */
  static state() {
    return window.history.state;
  }

  /**
   * Processed path including URLSearchParams
   *
   * @param { string } workspaceId
   * @param { URLSearchParams | undefined } urlSearchParams
   *
   * @returns {string} workspace id with SearchParam or only workspace id
   */
  static getPathWithSearchParams(
    workspaceId: string,
    urlSearchParams?: URLSearchParams,
  ) {
    if (!urlSearchParams) return workspaceId;

    switch (true) {
      case urlSearchParams.has("element"): {
        const elementId = urlSearchParams.get("element");
        return `${workspaceId}?element=${elementId}`;
      }
      case urlSearchParams.has("bookmark"): {
        const bookmarkId = urlSearchParams.get("bookmark");
        return `${workspaceId}?bookmark=${bookmarkId}`;
      }
      case urlSearchParams.has("layout"): {
        const layoutId = urlSearchParams.get("layout");
        return `${workspaceId}?layout=${layoutId}`;
      }
      default:
        return workspaceId;
    }
  }
}

export function syncHistory(
  workspaceId: string,
  urlSearchParams?: URLSearchParams,
) {
  const pathWithItem = ManageBrowserHistory.getPathWithSearchParams(
    workspaceId,
    urlSearchParams,
  );

  if (workspaceId === "DASHBOARD") {
    if (ManageBrowserHistory.state() !== "DASHBOARD") {
      // clicking the Hoylu logo will add a new point to the browser history
      ManageBrowserHistory.pushState("/", "DASHBOARD");
    }
  } else if (
    workspaceId === ManageBrowserHistory.state() &&
    workspaceId !== pathWithItem
  ) {
    // we avoid non-specific addresses, the address https://app.hoylu.com/640608771, will be replaced e.g. by address: https://app.hoylu.com/640608771/?element=f002eb82b65bcbefed129afcd2265131
    ManageBrowserHistory.replaceState(pathWithItem, pathWithItem);
  } else if (pathWithItem !== ManageBrowserHistory.state()) {
    // new point in browser history
    ManageBrowserHistory.pushState(pathWithItem, pathWithItem);
  }
}
